import React from 'react'
import type { Location } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { usePrevious } from 'hooks/use-previous'
// const getRouterPath = (pathname: string, params: Object): string => {
//   let result = pathname
//   for (let key in params) {
//     result = result.replace(params[key], ':' + key)
//   }
//   return result
// }
type Props = {
  location: Location
}

const Libraries = (props: Props): React.ReactNode => {
  // const prevOutlet = usePrevious(<Outlet />, !props.location.state?.modal)
  return (
    <>
      {/* {props.location.state?.modal && prevOutlet} */}
      <Outlet />
    </>
  )
}

export default Libraries
